import GeneralHead from "../head/GeneralHead";
import { Header } from "../layout/Header";
import { Props as FooterProps } from "../layout/Footer";
import { GeneralFoot } from "../layout/GeneralFoot";
import React, { FC } from "react";
import dynamic from "next/dynamic";

const Footer = dynamic<FooterProps>(() => import("components/front/layout/Footer"));

export const UnSupportError: FC = () => {
  return (
    <>
      <GeneralHead screenName={"動作対象外エラー"} />
      <Header />
      <main>
        <div
          style={{
            margin: "40px 10px",
            minHeight: "276px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div>
            <h1
              style={{
                fontSize: "24px",
                textAlign: "center",
                margin: "20px 0",
              }}
            >
              <span style={{ display: "inline-block" }}>申し訳ありません。対象外ブラウザです。</span>
            </h1>
            <p
              style={{
                fontSize: "14px",
                textAlign: "center",
                margin: "10px 0",
              }}
            >
              <p>Internet Explorerではこのページは表示できません。</p>
            </p>
            <div style={{ width: "100%", textAlign: "center" }}>
              <img src="/img/error.png" width={400} height={400} />
            </div>
            <p
              style={{
                fontSize: "14px",
                textAlign: "center",
                margin: "10px 0",
              }}
            >
              <p>Google Chrome/Mozilla Firefox/Microsoft Edge</p>
              <p>などで開いてお楽しみください。</p>
            </p>
          </div>
        </div>
      </main>
      <Footer />
      <GeneralFoot />
    </>
  );
};
